var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUndo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 35,
  viewBox: "0 0 35 35"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  x: 0.5,
  y: 0.5,
  fill: "#e6e6e6",
  stroke: "#e4e4e4",
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M28 17.5c0 5.247-4.253 9.5-9.5 9.5S9 22.747 9 17.5h1.357a8.142 8.142 0 1 0 2.09-5.427h2.66v1.357h-4.75V8.68h1.357v2.171A9.5 9.5 0 0 1 28 17.501"
}))));
export default SvgUndo;